import { SearchView } from "@/modules/plus/search/components/SearchView";

// The PLUS main page: one search box driving the decoder + model list.
export const HomePage: React.FC = () => <SearchView />;
